module.exports = __webpack_public_path__ + "img/r12.8ed821a5.jpg";